import { Button, Col, Container, Row } from "react-bootstrap";
const EmployeeWork = '/assets/png/employeesWork.webp';

import { Time_1, Alt_1} from "./images/svg/icons";

import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import "../scss/business-styling-component/employees-work.style.scss";

export const EmployeesWork = () => {
  const { t } = useTranslation();
  const BOOTSTRAP_MD_BREAKPOINT = 1440;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
  const isMobile = window.innerWidth < 576; // Bootstrap's mobile breakpoint
  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Container  className={`employees-work-container  ${isMobile ? 'px-3' : ''}`}>
      <Row className={`employees-work-row flex-column-reverse flex-sm-row`}>
        <Col md={6} className=" px-0 half-stretch">
          <img src={EmployeeWork} alt={t("EMPLOYEE_WORK_IMAGE_ALT")} className="img-fluid" />
        </Col>
        <Col md={6} className="d-flex flex-column justify-content-start pt-sm-4 mt-sm-1 align-items-start  px-0">
          <div className={`employees-work-content d-flex flex-column gap-3 justify-content-center ${isLargeScreen ? "padding-left-166" : ""}`}>
            <h2 className="employees-work-title mb-sm-4">{t("HOW_DOES_IT_WORK_FOR_EMPLOYEES")}</h2>
            <p className="employees-work-desc mb-0">{t("EMPLOYEES_WORK_DESC")}</p>
            <Row>
              {[
                {
                  icon: Time_1,
                  title: t("TIMELY_AND_SECURE_SALARY_PAYMENTS"),
                  description: t("TIMELY_AND_SECURE_SALARY_PAYMENTS_DESC"),
                },
                {
                  icon: Alt_1,
                  title: t("COMPREHENSIVE_INSURANCE_AND_SUPPORT"),
                  description: t("COMPREHENSIVE_INSURANCE_AND_SUPPORT_DESC"),
                },
              ].map(({ icon, title, description }, idx) => (
                <Col md={12} key={idx} className="d-flex align-items-start gap-4 px-0  padding-top-60">
                  <div>
                    <div className="employees-work-feature ">
                      <div className="employees-work-feature-icon  ">
                        <img src={icon} alt={title} className=""  />
                      </div>
                      <div className="d-flex flex-column justify-content-center align-items-center ">
                        <h3 className="employees-work-feature-title mb-0">{title}</h3>
                      </div>
                    </div>
                    <p className="employees-work-feature-desc mb-4 mb-0">{description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
